module.exports = __webpack_public_path__ + "static/media/outside-employment-activities.35325295.svg";